import Model from 'models/Model'
import { date, datetime } from 'helpers/format'

export const VOID = 'Void'
export const UNOPENED = 'Unopened'
export const ACKNOWLEDGED = 'Acknowledged'
export const WITH_CONCERN = 'w/concern'

export const ACKNOWLEDGED_STATUSES = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'Not yet',
  },
]

export const ECWT_STATUSES = [
  {
    value: VOID,
    label: 'Void',
  },
  {
    value: ACKNOWLEDGED,
    label: 'Acknowledged',
  },
  {
    value: WITH_CONCERN,
    label: 'w/ concern',
  },
  {
    value: UNOPENED,
    label: 'Unopened',
  },
]

export default class Ecwt extends Model {
  get id() {
    return this.model.id
  }

  get fileName() {
    return this.model.fileName
  }

  get fileDownload() {
    return this.model.fileDownload
  }

  get lessorName() {
    return this.model.lessorName
  }

  get createdAt() {
    const createdAt = this.model.createDate
    return date(createdAt, 'MMM dd, yyyy')
  }

  get createdAtDay() {
    const createdAtDay = this.model.createDate
    return date(createdAtDay, 'dd')
  }

  get createdAtMonth() {
    const createAtMonth = this.model.createDate
    return date(createAtMonth, 'MMM')
  }

  get createdAtYear() {
    const createAtYear = this.model.createDate
    return date(createAtYear, 'yyyy')
  }

  get isVoid() {
    return this.model.status === VOID
  }

  get isAcknowledge() {
    return this.model.isAcknowledge
  }

  get acknowledgeDate() {
    const acknowledgeDate = this.model.acknowledgeDate
    return date(acknowledgeDate, 'MMM dd, yyyy')
  }

  get acknowledgedText() {
    if (this.isAcknowledge) {
      return 'Yes'
    }
    return 'Not yet'
  }

  get acknowledgedColor() {
    if (this.isAcknowledge) {
      return '#2f9baa'
    }
    return '#fa6383'
  }

  get status() {
    if (this.model.status === VOID) {
      return 'Void'
    }

    if (this.model.status === UNOPENED) {
      return 'Unopened'
    }

    if (this.model.status === ACKNOWLEDGED) {
      return 'Acknowledged'
    }

    if (this.model.status === WITH_CONCERN) {
      return 'w/ concern'
    }

    return this.model.status
  }

  get statusColor() {
    if (this.model.status === VOID) {
      return '#FA6383'
    }

    if (this.model.status === UNOPENED) {
      return '#606060'
    }

    if (this.model.status === ACKNOWLEDGED) {
      return '#2F9BAA'
    }

    if (this.model.status === WITH_CONCERN) {
      return '#F27D33'
    }

    return '#606060'
  }

  get embedPdf() {
    if (this.model.pdfFile) {
      return URL.createObjectURL(this.model.pdfFile) + '#toolbar=0'
    }
    return null
  }

  get acknowledgeDateView() {
    return datetime(this.model.acknowledgeDate)
  }

  get createAtView() {
    const createdAt = this.model.createDate
    return date(createdAt)
  }
}
